import axios from 'axios'

const address = 'https://weixin.bluetonemusic.cn/' /* 项目打包 */
// let address = '/request/'; /* 本地运行打开*/


//添加请求拦截器
axios.interceptors.request.use(config => {
        let token = window.localStorage.getItem("accessToken");
        // let token='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6ImJ0In0.eyJpc3MiOiJhcGkuYmx1ZXRvbmVtdXNpYy5jbiIsImF1ZCI6ImJsdWV0b25lbXVzaWMiLCJqdGkiOiJidCIsImlhdCI6MTU4NjU2Nzk1NCwibmJmIjoxNTg2NTY3OTUzLCJleHAiOjE1ODY2NTQzNTQsInVzZXJfaWQiOjF9.5DakdHyvfvsJifzrj9qjshVZBAnHWOTu_Cf5dTK5fpM';
        if (token) {
            //将token放到请求头发送给服务器,将tokenkey放在请求头中
            config.headers.token = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export const post = function postPromise(params, path) {
    return new Promise((resolve) => {
        axios.post(address + path, params).then((res) => {
            if (res.headers.token) {
                window.localStorage.setItem("accessToken", res.headers.token)
            }
            if (res.status == '200') {
                resolve(res.data, res.config.headers.token)
            } else {
                console.log(res);
                Message.success(res.msg)
            }
        }).catch((err) => {
            console.log(err);
            Message.success(err)
        });
    })
};

export const get = function getPromise(params, path) {
    return new Promise((resolve) => {
        axios.get(address + path, {
            params: params
        }).then((res) => {
            if (res.status == '200') {
                resolve(res.data)
            } else {
                console.log(res);
                Message.success(res.msg)
            }
        }).catch((err) => {
            console.log(err);
            Message.success(err)
        });
    })
};


export const upLoudFile = function getFile(params, path) {

    return new Promise((resolve) => {
        axios.post(address + path, params, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then((res) => {
            if (res.status == 200) {
                resolve(res.data)
            }
        }).catch((err) => {
            console.log(err);
            Message.success(err)
        })
    })
};



/*******  */
export const aiPost = function postPromise(params, path) {
    return new Promise((resolve) => {
        axios.post(address + path,params).then((res) => {
            if (res.status == '200') {
                resolve(res.data)
            } else {
                console.log(res);
                Message.success(res.msg)
            }
        }).catch((err) => {
            console.log(err);
            Message.success(err)
        });
    })
};

export const aiGet = function getPromise(params, path) {
    return new Promise((resolve) => {
        axios.get(address + path, {params: params}).then((res) => {
            if (res.status == '200') {
                resolve(res.data)
            } else {
                console.log(res);
                Message.success(res.msg)
            }
        }).catch((err) => {
            console.log(err);
            Message.success(err)
        });
    })
};

export const apiAdres = function() {
    return address
}



// WEBPACK FOOTER //
// ./src/api/index.js